module.exports = __webpack_public_path__ + "static/media/17.47d6b705.JPG";